<button
  class="chip-button ps-xsmall-x"
  [class.chip-default]="theme === ChipTheme.DEFAULT"
  [class.chip-active]="theme === ChipTheme.ACTIVE"
  [attr.aria-label]="title"
  [attr.title]="title"
  [disabled]="disabled"
  (blur)="blur.emit($event)"
  (click)="chipClicked.emit($event)"
>
  <ng-content *ngIf="!text"></ng-content>
  <span *ngIf="text" class="ps-xxsmall-y flex flex--center">
    <span class="font-body-1 regular-type">{{ text }}</span>
    <fcom-icon *ngIf="iconName" [category]="iconCategory" [name]="iconName" class="is-xxsmall ps-xxsmall-l"></fcom-icon>
  </span>
</button>
